import { useTheme } from "@/context/ThemeContext";
import { Sun, Moon, ShieldCheck, Cpu } from "lucide-react";

export default function Settings() {
  const { theme, toggle } = useTheme();
  return (
    <div className="max-w-2xl space-y-6" data-testid="settings-page">
      <h1 className="text-2xl font-head font-bold">Settings</h1>

      <div className="rounded-2xl border border-slate-800 bg-slate-900/40 p-6">
        <h2 className="font-head font-semibold mb-4">Appearance</h2>
        <div className="flex items-center justify-between">
          <div>
            <div className="font-medium">Theme</div>
            <div className="text-sm text-slate-400">Switch between dark and light mode.</div>
          </div>
          <button data-testid="settings-theme-toggle" onClick={toggle}
            className="h-10 px-4 rounded-xl border border-slate-700 flex items-center gap-2 text-sm hover:border-emerald-500/50 transition-colors">
            {theme === "dark" ? <><Moon className="h-4 w-4" /> Dark</> : <><Sun className="h-4 w-4" /> Light</>}
          </button>
        </div>
      </div>

      <div className="rounded-2xl border border-slate-800 bg-slate-900/40 p-6">
        <h2 className="font-head font-semibold mb-4 flex items-center gap-2"><Cpu className="h-4 w-4 text-emerald-400" /> Models</h2>
        <p className="text-sm text-slate-400">Model providers are configured by the platform owner in the Admin panel. There are no credits, coins or usage meters — builds run on the owner-supplied model configuration.</p>
      </div>

      <div className="rounded-2xl border border-slate-800 bg-slate-900/40 p-6">
        <h2 className="font-head font-semibold mb-4 flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-emerald-400" /> Security</h2>
        <ul className="text-sm text-slate-400 space-y-2 list-disc pl-4">
          <li>Secrets are encrypted at rest and never sent to the browser.</li>
          <li>Generated apps run in a sandboxed iframe, isolated from the host.</li>
          <li>All privileged actions are recorded in the audit log.</li>
        </ul>
      </div>
    </div>
  );
}
